import { AsyncPipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { SearchLimitNotificationService } from '@ecs-services/search-limit-notification.service';
import { SearchStoreService } from '@ecs-services/search/search-store.service';
import { isTypeDesignationDataResult } from '@ecs-services/search/search.helper';
import { TypeDesignationDataResult } from '@ecs-services/search/search.interface';
import { TranslatePipe } from '@ngx-translate/core';
import { SelectableRow } from '@os-components';
import { SewTabBar, SewTabBarItem } from '@sew/ui-components-angular/standalone';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PartTableSkeletonComponent } from '../../../components/part-table-skeleton/part-table-skeleton.component';
import { SparePartsResultComponent } from '../spare-parts-result/spare-parts-result.component';
import { SpareParts } from '../spare-parts-result/spare-parts.interface';
import { SparePartListsTableComponent } from './components/spare-parts-lists-table/spare-part-lists-table.component';

export interface SparePartList {
    id: string;
    language: string;
    productName: string;
    url: string;
}

const isSparePartListWithEntries = (
    result: TypeDesignationDataResult | undefined
): result is TypeDesignationDataResult & { sparePartLists: SparePartList[] } =>
    result !== undefined && Array.isArray(result.sparePartLists) && result.sparePartLists.length > 0;

@Component({
    selector: 'ecs-type-designation-result',
    templateUrl: './type-designation-result.component.html',
    styleUrls: ['./type-designation-result.component.scss'],
    imports: [
        SewTabBar,
        SewTabBarItem,
        SparePartListsTableComponent,
        SparePartsResultComponent,
        PartTableSkeletonComponent,
        AsyncPipe,
        TranslatePipe,
    ],
})
export class TypeDesignationResultComponent implements OnInit, OnDestroy {
    public typeDesignationData?: Observable<SelectableRow<SparePartList>[] | undefined>;
    public freeTextData?: Observable<(TypeDesignationDataResult & { spareParts: SpareParts }) | undefined>;

    public constructor(
        private searchStore: SearchStoreService,
        public searchLimitNotificationService: SearchLimitNotificationService
    ) {}

    public ngOnInit(): void {
        const typeDesignationResult = this.searchStore.getSearchResult(isTypeDesignationDataResult, false);
        this.typeDesignationData = typeDesignationResult.pipe(
            filter(isSparePartListWithEntries),
            map((value) =>
                value.sparePartLists.map(
                    (sparePartList) =>
                        ({
                            isSelectableRow: false,
                            isDisabled: false,
                            rowData: sparePartList,
                        }) as SelectableRow<SparePartList>
                )
            )
        );
        this.freeTextData = typeDesignationResult.pipe(
            filter(
                (value): value is TypeDesignationDataResult & { spareParts: SpareParts } =>
                    value?.spareParts !== undefined
            )
        );
    }

    public ngOnDestroy(): void {
        this.searchLimitNotificationService.setVisibility(false);
    }
}
